<template>
    <form class="mt-3" @submit.prevent="createAddress">
        <h3 class="card-title mb-4">
            {{ $t('pages.subscription.start.address.invoice_address') }}
        </h3>

        <address-form v-bind:value="address" @input="address = $event" :countries="countries"
                      validation-name-prefix="invoice_address."/>

        <hr>

        <h3 class="card-title mb-4">
            {{ $t('pages.subscription.start.address.delivery_address') }}
            <error-no-form-field input="delivery_address"/>
        </h3>
        <button class="btn btn-outline-dark btn-sm mb-2" @click.prevent="copyInvoiceAddress" v-if="copyButtonEnabled">
            {{ $t('pages.subscription.start.address.same_as_invoice') }}
        </button>

        <div class="alert alert-danger shadow-sm pb-0">
            <p v-html="$t('pages.subscription.start.address.delivery_add_lux_only')"></p>
        </div>

        <address-form v-bind:value="deliveryAddress" @input="deliveryAddress = $event" :countries="countries"
                      :lux-only="true" validation-name-prefix="delivery_address."/>

        <div class="form-group">
            <button class="btn btn-primary">
                {{ $t('pages.subscription.start.address.continue') }}
            </button>
        </div>

    </form>
</template>

<script>
import CountryRepository from "../../../repositories/Countries/CountryRepository";
import AddressForm from "./Includes/AddressForm";
import SubscriptionStartRepository from "../../../repositories/Subscription/SubscriptionStartRepository";

export default {
    name: "SubscriptionStartAddress",
    components: {AddressForm},
    data: () => ({
        isLoading: false,
        address: {},
        deliveryAddress: {},

        countries: []
    }),
    methods: {
        createAddress() {
            SubscriptionStartRepository.createAddress({
                invoice_address: this.address,
                delivery_address: this.deliveryAddress
            }).then((res) => {
                this.$emit('step-completed');
            })
        },

        copyInvoiceAddress() {
            this.deliveryAddress = JSON.parse(JSON.stringify(this.address));
            this.deliveryAddress.country_id = 442;
        }
    },
    computed: {
        copyButtonEnabled() {
            return this.address.country_id === 442;
        }
    },
    mounted() {
        this.address.full_name = this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name;

        CountryRepository
            .getSimple()
            .then((res) => this.countries = res.data);
    }
}
</script>

<style scoped>

</style>
